module.exports = __webpack_public_path__ + "fonts/MyriadPro-CondIt.5c38cc5.ttf";